var render = function render(){var _vm=this,_c=_vm._self._c;return _c('noscript',{staticClass:"nuxt-speedkit__noscript",inlineTemplate:{render:function(){var _vm=this,_c=_vm._self._c;return _vm._t("default")},staticRenderFns:[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }